import styled, { createGlobalStyle } from "styled-components";

export const Global = createGlobalStyle`

* {
  box-sizing: border-box;

}
`;

export const Dip = styled.div``;
